import React from 'react';

import Thumb from '../img/red-onion.png';
import Img from '../img/red-onion2.png';

const RedOnion = {
    id: 101, permalink: "red-onion", thumb: Thumb, title: "Red Onion", category: "React", categoryURL: "react", detailImg1: Thumb, detailImg2: Img, previewTxt: "Preview", previewURL: "https://red-onion-foo.web.app/", sourceTxt: "", sourceURL: "", description: <>
        <h3>Red Onion is a restaurant web app.</h3>
        <p>&nbsp;</p>

        <h5>Main Featured:</h5>
        <ul>
            <li>Data load from live database</li>
            <li>Inventory form to add Food to database</li>
            <li>Cart page to manage cart, set payment info and payment</li>
            <li>Integrated Stripe payment system</li>
        </ul>

        <h5>Technology Used:</h5>
        <ul>
            <li>React, Node, Firebase, Heroku, MongoDB, Stripe.</li>
        </ul>
    </>
};
export default RedOnion;